<template>
    <div id="index">
        <top-header v-if="ShowHeader"></top-header>
        <left-navigation v-if="ShowHeader"></left-navigation>
        <div class="right-content" :style="ShowHeader ? null : {'top': '0px','left': '0px !important'}" :class="{'bg1':$route.path=='/Overviews'}">
            <div id="children-view" :class="{'minH': $route.path=='/DevopsPreview','minH2': $route.path=='/Overviews'}" :style="ShowHeader ? null : {'top': '0px','right': '0px'}">
                <div class="mask" v-show="$store.state.mask"></div>
                <router-view>
                </router-view>
            </div>
        </div>
    </div>
</template>
<script>
import Header from '../components/PublicAssembly/header'
import LeftNavigation from '../components/PublicAssembly/leftNavigation'
export default {
    data() {
        return {
            ShowHeader: true,
            options:false,
            client:null,
            link:null,
            title:null,
            _beforeUnload_time:0,
            _gap_time:0,
        }
    },
    created() {
        // this.$mqtt.end()
        this.link=require('@/assets/image/index/favicon'+this.cssType+'.png')
        this.title = this.cssType==0?'捷云物联':'天机云平台'
        this.$store.state.userData={avatar:''}
        this.getUserDate()
        this.getData();     //获取系统配置
        document.title = this.title; // 动态修改网站标题
        this.changeIco()
        this.getUserConfig();
        this.getUserMenus();
        // this.getFuncList();
        // this.regLoginOut();
        this.$store.state.mask=false;
        //console.log(this.getCookie('SESSION'));
    },
    mounted() {
      window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
      window.addEventListener('unload', e => this.unloadHandler(e))
    },
    methods: {
        // 计算离线时间
        // regLoginOut(){
        //     let closeTime = localStorage.getItem('closeTime');
        //     let nowTime = new Date().getTime()
        //     if(nowTime-closeTime>60000){
        //         localStorage.removeItem('loginState')
        //     }
        // },
        getUserDate(){
            this.get('/UserProfile/get').then((res)=>{
                if(res.success){
                    this.$store.state.userData = JSON.parse(localStorage.getItem("userData"))
                    localStorage.setItem('userData',JSON.stringify(res.result))
                }else{
                    this.$store.state.userData = JSON.parse(localStorage.getItem("userData"))
                }
                this.options = {
                    clientId:this.$store.state.userData.code+'_message',
                    connectTimeout: 600000,
                    clean: true
                }
                if(this.$route.path!='/ReportForms'){
                  if(this.$store.state.client){
                    this.$store.state.client.end()
                  }
                  this.$store.state.client =  this.$mqtt.connect(this.$store.state.MQTT_SERVICE, this.options)
                  this.client =  this.$store.state.client
                  this.mqttMSG()
                }
            })
        },
        mqttMSG () {
            // mqtt连接
            let url = 'sys/user/' + this.$store.state.userData.code + '/message/push'
            this.client.subscribe(url, { qos: 1 }, (error) => {
                if(!error) {
                    // console.log('订阅用户消息成功')
                }else{
                    // console.log('订阅用户消息失败')
                }
            })
            // 接收消息处理
            this.client.on('message', (topic, message) => {
                if(topic==url){
                    this.getMessagelist({pageNumber:1,length:this.$store.state.userConfig.rowsPerPage});
                    this.$forceUpdate()
                }
                // this.msg = message.toString()
            })
            // 链接异常处理
            this.client.on('error', (error) => {
                // console.log('连接失败:', error)
                // this.client = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, this.options)
            })
        },
        //隐藏头部及左侧列表
        ChangeHeaderShow(){
          this.ShowHeader = !this.ShowHeader;
        },
        beforeunloadHandler(){
          this._beforeUnload_time=new Date().getTime();
        },
        unloadHandler(e){
          this._gap_time = new Date().getTime()-this._beforeUnload_time;
          //判断是窗口关闭还是刷新
          if(this._gap_time<=5){
            localStorage.removeItem('indexLoad')
          }
        },

        //获取用户配置
        getUserConfig(){
          // 静音配置
            this.get('/UserConfig/get',{name:'mute'}).then((res)=>{
                if(res.success){
                  this.$store.state.userConfig.mute=res.result.value?Number(res.result.value):0
                  localStorage.setItem('mute',this.$store.state.userConfig.mute)
                }
            })

            // 页码配置
            if(localStorage.getItem('rowsPerPage')){
                this.$store.state.userConfig.rowsPerPage = Number(localStorage.getItem('rowsPerPage'))
                this.getMessagelist({pageNumber:1,length:this.$store.state.userConfig.rowsPerPage});
            }else{
              this.get('/UserConfig/get',{name:'rowsPerPage'}).then((res)=>{
                  if(res.success){
                      this.$store.state.userConfig.rowsPerPage=res.result.value?Number(res.result.value):10
                      localStorage.setItem('rowsPerPage',res.result.value?Number(res.result.value):10)
                      // console.log(this.$store.state.userConfig.rowsPerPage)
                      this.getMessagelist({pageNumber:1,length:this.$store.state.userConfig.rowsPerPage});
                  }
              })
            }
            //
            this.get('/UserConfig/get',{name:'homepage'}).then((res)=>{
                if(res.success&&res.result.value){
                  this.$store.state.userConfig.homepage=JSON.parse(res.result.value).path
                }else{
                   this.$store.state.userConfig.homepage='/CompanyConsole/IndexEditShow'
                }
                localStorage.setItem('homepage',this.$store.state.userConfig.homepage)
            })
        },
        // 获取消息列表
        getMessagelist(parm,checkWarning){
            this.get('/Message/query',parm).then((res)=>{
                if(res.success){
                    this.$store.state.messageList=res.result.data
                }else{
                    this.$message({
                        message: `获取消息列表数据失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //获取权限
        getUserMenus(){
            this.get('/Authority/userMenus').then((res)=>{
                if(res.success){
                    this.$store.state.userMenus = res.result
                    this.getFuncList();
                }else{
                    this.$message({
                        type: 'warning',
                        message: `获取用户权限失败：${res.message}`
                    })
                }
            })
        },
        // 获取功能集
        getFuncList(){
            this.get('/Function/getList').then((res)=>{
                if(res.success){
                    this.$store.state.functionList=[]
                    for(let menu of this.$store.state.userMenus){
                        for(let func of res.result){
                            if(menu == func.id){
                                this.$store.state.functionList.push(func.code)
                            }
                        }
                    }
                }
            })
        },
        // 修改标题ico
        changeIco(){
            let $favicon = document.querySelector('link[rel="icon"]');
            if ($favicon !== null) {
                $favicon.href = this.link;
            } else {
                $favicon = document.createElement("link");
                $favicon.rel = "icon";
                $favicon.href = this.link;
                document.head.appendChild($favicon);
            }
            // this.$forceUpdate()
        },
        //获取cookie
        getCookie(name) { //获取指定名称的cookie值
            // (^| )name=([^;]*)(;|$),match[0]为与整个正则表达式匹配的字符串，match[i]为正则表达式捕获数组相匹配的数组；
            var arr = document.cookie.match(new RegExp("(^| )"+name+"=([^;]*)(;|$)"));
            if(arr != null) {
                // console.log(arr);
                return unescape(arr[2]);
            }
            return null;
        },
        //获取系统配置
        getData(){
            this.get('/SystemConfig/getList').then((res)=>{
                if(res.success){
                    for(let obj of res.result){
                        if(obj.name=='guestTime'){
                            if(obj.value==0||obj.value==null){
                                return
                            }
                            let value = obj.value==null?5:obj.value
                            localStorage.setItem('guestTime',value)
                            this.lookTime(value)
                        }else if(obj.name == 'verifyCodeModule'){
                            let value = obj.value
                            localStorage.setItem('verifyCodeModule',value)
                            //console.log(value)
                        }
                    }
                }
            })
        },
    },
    components:{
        "top-header":Header,
        "left-navigation":LeftNavigation,
    },
    destroyed() {
      window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
      window.removeEventListener('unload', e => this.unloadHandler(e))
    },
}
</script>
<style scoped>
	.minH{
		min-height: 905px !important;
	}
  .minH2{
    min-height: 868px !important;
  }
    #index{
        width: 100%;
        min-width: 1366px;
        display: table;
    }
    .right-content{
        position: absolute;
        top: 75px;
        bottom: 0;
        left: 250px;
        right: 0;
        /*overflow: auto;*/
        min-width: 1116px;
        min-height: 796px;
    }
    .mask{
        position: fixed;
        top: 0;
        bottom:0;
        background-color: rgba(0, 0, 0, .4);
        z-index: 999;
        left: 0;
        right: 0;
    }
    #children-view{
        position: absolute;
        top: 16px;
        bottom: 0;
        left: 0px;
        right: 14px;
        min-height: 780px;
    }
    .bg1{
      background: #ECEEF2;
    }
</style>



// WEBPACK FOOTER //
// src/components/index.vue